import React from "react";
import { Tooltip } from "@mui/material";

const Tooltips = ({ htmlTooltip, placement, htmlElementHover }) => {
    return (
        <Tooltip title={<span style={{ whiteSpace: "pre-line" }}>{htmlTooltip ? htmlTooltip : ""}</span>} placement={placement}>
            <div className="tooltip-container">
                {htmlElementHover}
            </div>
        </Tooltip>
    );
};

export default Tooltips;
